import React from 'react';
import s from '../../styles/molecules/news-skeleton.module.scss';

export const NewsSkeleton: React.FC = () => {
  return (
    <div className={s.skeletonWrapper}>
      <div className={s.skeletonTitle}></div>
      <div className={s.skeletonDate}>
        <span className={s.date}></span>
        <span className={s.tag}></span>
      </div>
      <div className={s.skeletonContent}>
        <div className={s.line}></div>
        <div className={s.line}></div>
        <div className={s.line}></div>
        <div className={s.lineShort}></div>
      </div>
    </div>
  );
};